import commercialHero from 'assets/images/psp/PSPHero/commercial-hero.webp';

import Unit5X5Icon from 'assets/images/psp/SizeGuide/5x5.webp';
import Unit5X10Icon from 'assets/images/psp/SizeGuide/5x10.webp';
import Unit10X10Icon from 'assets/images/psp/SizeGuide/10x10.webp';
import Unit10X20Icon from 'assets/images/psp/SizeGuide/10x20.webp';
import Unit10X25Icon from 'assets/images/psp/SizeGuide/10x25.webp';
import Unit10X30Icon from 'assets/images/psp/SizeGuide/10x30.webp';

import HomeIcon from 'assets/images/psp/SizeGuide/home.svg';
import MobileIcon from 'assets/images/psp/SizeGuide/mobile.svg';
import SettingsIcon from 'assets/images/psp/SizeGuide/settings.svg';
import PhoneIcon from 'assets/images/psp/SizeGuide/phone.svg';
import BegIcon from 'assets/images/psp/SizeGuide/beg.svg';
import RestaurantIcon from 'assets/images/psp/SizeGuide/restaurant.svg';

import SelfStorageUnitIcon from 'assets/images/psp/SizeGuide/self-storage-unit.svg';
import WarehouseLeaseIcon from 'assets/images/psp/SizeGuide/warehouse-lease.svg';
import OfficeExpansionIcon from 'assets/images/psp/SizeGuide/office-expansion.svg';
import DrivewayIcon from 'assets/images/psp/SizeGuide/driveway.svg';

import FaQHeadingIcon from 'assets/images/psp/Faq/StorageImage.svg';

import ManAndWomanStorage from 'assets/images/psp/FeaturedContentImages/electric-related-2.webp';
import ElevatingEfficiency from 'assets/images/psp/FeaturedContentImages/electric-related-3.webp';
import Inventory from 'assets/images/psp/FeaturedContentImages/electric-related-4.webp';
import IndoorclimateControlledStorageUnits from 'assets/images/psp/SelfStorage/indoor-climate-controlled-storage-units.webp';

import CommercialStorage from 'assets/images/psp/PSPVideo/commercial-storage.webp';
import SecurityFeatures from 'assets/images/psp/PSPVideo/security-features.webp';

import { storageCategories } from 'pages/PSPPage/utils/getPSPLinks';

const reviews = [
	{
		title: 'Very Efficient and Caring',
		stars: 5,
		text: 'Luis was the greatest help ever and wasted no time to find me what I needed for my business.',
		customerName: 'Ramon Rodriguez',
		date: 'Nov 9, 2023',
		link: 'https://www.trustpilot.com/reviews/654d05cae1bafe8205d1355b',
	},
	{
		title: 'I have a storage need for 6 months…',
		stars: 5,
		text: 'I have a storage need for 6 months while my business transitions to a new space on Research Blvd. made a call. Booked a 10 x 25 unit on 44 Research Place. The gentleman who fielded my call was outstanding. Thank you',
		customerName: "Sean Harry O'Donovan",
		date: 'Jul 15, 2022',
		link: 'https://www.trustpilot.com/reviews/62d183de4c35e69ec5102844',
	},
	{
		title: 'Definitely great customer service ',
		stars: 5,
		text: 'Definitely great customer service. The woman at the desk that helped me on 3/16 was amazing. Definitely helped me find the best unit for my business and convinced me to leave my old storage unit to move everything to Storage post. I highly recommend Storage Post on Bruckner Blvd.',
		customerName: 'Ashley Phillips',
		date: 'Mar 18, 2021',
		link: 'https://www.trustpilot.com/reviews/605373ddf85d75041882480c',
	},
	{
		title: 'Easy transaction',
		stars: 5,
		text: 'Honestly, I was in a crunch to get an affordable easy solution for my business storage needs and Self Storage and their staff offered just that. In a matter of minutes I was shown a perfect unit, given the contract and terms and within an hour my belongings were put away. My time is money and with the help of the staff at Self Storage, I saved not only on the rental but in the time it took to get everything done.',
		customerName: 'GABRIEL',
		date: 'Nov 13, 2015',
		link: 'https://www.trustpilot.com/reviews/564500580000ff000919bc17',
	},
];

const faqs = [
	{
		question:
			'How do I determine what size commercial storage unit I need?',
		answer: 'Start by listing everything you plan to store and measuring larger items. Our size guide shows typical capacity, but visiting a facility to see units in person helps. Many business owners find a 10x10 unit works well for small to medium operations, while growing businesses often need 10x20 or larger industrial storage units.',
	},
	{
		question: 'Can I use business storage for tax deductions?',
		answer: 'Storage costs for legitimate business purposes may be tax-deductible as a business expense. Keep receipts and consult with your accountant about how storage rental fits into your specific business structure and tax situation.',
	},
	{
		question:
			"What's the difference between commercial storage and regular self storage?",
		answer: 'Commercial storage units are designed for business use and often offer features like loading docks, extended access hours, larger unit sizes, and business-friendly contracts. Some facilities also provide services like package receiving and freight coordination.',
	},
	{
		question: 'How often can I access my business storage unit?',
		answer: 'Most commercial storage facilities offer extended access hours, with many providing 24/7 access for business customers. Check with individual facilities about their specific access policies, as some offer key card systems for round-the-clock convenience.',
	},
	{
		question: 'Do I need insurance for items in commercial storage?',
		answer: "While storage facilities provide security measures, they typically aren't responsible for your stored items. Check if your business insurance covers off-site storage, or consider purchasing storage insurance through the facility or a third-party provider.",
	},
	{
		question: 'Can I have items delivered directly to my storage unit? ',
		answer: 'Many commercial storage facilities accept deliveries for business customers, though policies vary. Some charge receiving fees while others include it in premium storage packages. This service can be especially valuable for online retailers managing inventory.',
	},
	{
		question: "What items aren't allowed in business storage units?",
		answer: 'Prohibited items typically include hazardous materials, perishable goods, live animals, illegal substances, and highly flammable materials. Each facility has specific guidelines, so review the lease agreement carefully and ask about any questionable items.',
	},
	{
		question: 'How much notice do I need to give before moving out?',
		answer: "Most business storage agreements are month-to-month, requiring 30 days' notice before vacating. This flexibility makes it easy to adjust your storage needs as your business grows or changes direction.",
	},
];

export const CommercialContent = {
	type: 'Commercial',
	reviews: reviews,
	sections: [
		{
			title: 'Business Storage Hero',
			background: 'default',
			modules: [
				{
					type: 'hero',
					id: 'business-storage-hero',
					props: {
						content: {
							title: 'Find Affordable Commercial Self Storage',
							description:
								"Running out of space for your growing business? Commercial storage units provide flexible, cost-effective solutions for inventory, equipment, documents, and seasonal items without the commitment of expensive warehouse leases. Whether you're a home-based entrepreneur, small business owner, or managing multiple locations, [business storage](https://www.selfstorage.com/blog/small-business-inventory-storage-2/) can help you organize, declutter, and scale your operations while keeping costs manageable.\n\n **SelfStorage.com** makes it simple to find and reserve the perfect commercial storage facility for your business needs.",
							image: commercialHero,
							CTAtext: 'Find Commercial Self Storage',
						},
					},
				},
			],
		},

		{
			title: 'video content 1',
			noPadding: true,
			background: 'blueGradient',
			modules: [
				{
					title: 'Business Storage Options',
					type: 'video',
					props: {
						content: {
							title: 'The Small Business Inventory Conundrum',
							description:
								"If you're running a small business, every day can pretty much be a juggling act. You've got your hands full promoting your business and keeping your customers happy, but here's the snag — your inventory is growing, and your storage space isn't.",
							imageSrc: CommercialStorage,
							suffixText:
								"Boxes are piling up in home offices and [garages](https://www.selfstorage.com/blog/diy-garage-storage/) that aren't big enough for growing inventory needs, making it tough to store and organize products effectively, keep inventory secure, and access older stock when needed. Commercial storage units provide the extra room you need, without the high cost or commitment of larger commercial premises.",
						},
					},
				},
			],
		},

		{
			title: 'unit size chart 1',
			modules: [
				{
					type: 'cardStrip',
					props: {
						heading: 'Choose Your Business Storage Size',
						cardData: [
							{
								title: '5x5 Storage Unit',
								content:
									'- **Common items:** Office supplies, small inventory, documents\n' +
									'- **Capacity:** 10-15 file boxes, desk supplies, promotional materials\n' +
									'- **Best for:**  Home-based businesses, consultants',
								imageSrc: Unit5X5Icon,
								contentAlign: 'text-left',
							},
							{
								title: '5x10 Storage Unit',
								content:
									'- **Common items:** Seasonal inventory, equipment, archived files\n' +
									'- **Capacity:** Small furniture, 20-30 boxes, office equipment\n' +
									'- **Best for:** Online retailers, service businesses',
								imageSrc: Unit5X10Icon,
								contentAlign: 'text-left',
							},
							{
								title: '10x10 Storage Unit',
								content:
									'- **Common items:** Large inventory, furniture, multiple equipment pieces\n' +
									'- **Capacity:** Contents of small office, trade show displays, bulk inventory\n' +
									'- **Best for:** Growing businesses, retail operations',
								imageSrc: Unit10X10Icon,
								contentAlign: 'text-left',
							},
							{
								title: '10x20 Storage Unit',
								content:
									'- **Common items:** Commercial vehicle storage, large inventory stockpiles\n' +
									'- **Capacity:** Vehicle + equipment, extensive inventory, furniture sets\n' +
									'- **Best for:** Contractors, delivery services, established businesses',
								imageSrc: Unit10X20Icon,
								contentAlign: 'text-left',
							},
							{
								title: '10x25 Storage Unit',
								content:
									'- **Common items:** Multiple vehicles, warehouse-style inventory storage\n' +
									'- **Capacity:** 2 vehicles or extensive business equipment and inventory\n' +
									'- **Best for:** Growing e-commerce businesses, equipment rental companies',
								imageSrc: Unit10X25Icon,
								contentAlign: 'text-left',
							},
							{
								title: '10x30 Storage Unit',
								content:
									'- **Common items:** Large-scale inventory management, multiple commercial vehicles\n' +
									'- **Capacity:** Fleet vehicles, bulk inventory, complete office contents\n' +
									'- **Best for:** Established businesses, wholesale operations, logistics companies',
								imageSrc: Unit10X30Icon,
								contentAlign: 'text-left',
							},
						],
					},
				},
			],
		},

		{
			title: 'unit size chart 2',
			noPaddingTop: true,
			modules: [
				{
					type: 'cardStrip',
					props: {
						heading:
							'What Businesses Store in Commercial Storage Units',
						cardData: [
							{
								title: 'Home-Based Businesses',
								content:
									'- **Common items:** Inventory, shipping supplies, seasonal products\n' +
									'- **Benefits:** Separate business from personal space, tax deductions',
								imageSrc: HomeIcon,
								contentAlign: 'text-left',
							},
							{
								title: 'Online Retailers',
								content:
									'- **Common items:** Product inventory, packaging materials, returns\n' +
									'- **Benefits:** Easy access for fulfillment, cost-effective scaling',
								imageSrc: MobileIcon,
								contentAlign: 'text-left',
							},
							{
								title: 'Contractors',
								content:
									'- **Common items:** Tools, equipment, materials, commercial vehicles\n' +
									'- **Benefits:** Secure equipment storage, organized job site prep',
								imageSrc: SettingsIcon,
								contentAlign: 'text-left',
							},
							{
								title: 'Service Professionals',
								content:
									'- **Common items:** Files, equipment, promotional materials\n' +
									'- **Benefits:** Professional image, document security',
								imageSrc: PhoneIcon,
								contentAlign: 'text-left',
							},
							{
								title: 'Retail Businesses',
								content:
									'- **Common items:** Excess inventory, seasonal displays, fixtures\n' +
									'- **Benefits:** Manage cash flow, store off-season items',
								imageSrc: BegIcon,
								contentAlign: 'text-left',
							},
							{
								title: 'Restaurants/Catering',
								content:
									'- **Common items:** Equipment, supplies, furniture, promotional items\n' +
									'- **Benefits:** Reduce overhead, store event-specific items',
								imageSrc: RestaurantIcon,
								contentAlign: 'text-left',
							},
						],
					},
				},
			],
		},

		{
			title: 'video content 2',
			background: 'blueGradient',
			modules: [
				{
					title: 'Business Storage Options',
					type: 'video',
					props: {
						content: {
							title: 'Security Features That Protect Your Business Assets',
							description:
								'Your business inventory and equipment represent significant investments that deserve [proper protection](https://www.selfstorage.com/blog/24-hour-storage-amenities/).\n\n' +
								'Modern commercial storage facilities offer advanced security measures including 24/7 surveillance, gated access, individual unit alarms, and on-site management.',
							imageSrc: SecurityFeatures,
							suffixText:
								'Many locations also provide [climate control options](https://www.selfstorage.com/blog/24-hour-storage-amenities/) to protect sensitive items like electronics, documents, and products that could be damaged by temperature fluctuations.',
						},
					},
				},
			],
		},

		{
			title: 'content section',
			background: 'blueWithMap',
			modules: [
				{
					title: 'Industrial Storage Units for Growing Operations',
					type: 'content',
					props: {
						title: 'Industrial Storage Units for Growing Operations',
						contentType: 'row-type',
						theme: 'dark',
						content: [
							'When your business needs serious space, industrial storage units offer warehouse-style solutions without the long-term commitment.\n\n' +
								'These larger units accommodate everything from commercial storage for delivery fleets to extensive inventory management for expanding operations.\n\n' +
								'The flexibility to scale up or down as your business evolves makes commercial storage units to rent a smart financial choice.',
						],
					},
				},
			],
		},

		{
			title: 'unit size chart 3',
			modules: [
				{
					type: 'cardStrip',
					props: {
						heading: 'Business Storage Costs vs. Alternatives',
						cardData: [
							{
								title: 'Self-Storage Unit',
								content:
									'$50-300/month \n\n' +
									'Minimal paperwork, move-in ready units, month-to-month rentals and easy upgrades.',
								imageSrc: SelfStorageUnitIcon,
								contentAlign: 'text-left',
							},
							{
								title: 'Warehouse Lease',
								content:
									'$500-2,000/month \n\n' +
									'Requires credit checks and long-term contracts.',
								imageSrc: WarehouseLeaseIcon,
								contentAlign: 'text-left',
							},
							{
								title: 'Office Expansion',
								content:
									'$800-3,000+/month \n\n' +
									'1-5 year leases are difficult to change or break; build-out costs and lease negotiations cause delays and overspending.',
								imageSrc: OfficeExpansionIcon,
								contentAlign: 'text-left',
							},
							{
								title: 'Warehouse Storage Space for Rent',
								content:
									'$200-800/month \n\n' +
									'Shared space agreements are the norm, often come with access and security constraints.',
								imageSrc: DrivewayIcon,
								contentAlign: 'text-left',
							},
						],
					},
				},
			],
		},

		{
			title: 'Reviews Section',
			background: 'lighterBlue',
			modules: [
				{
					type: 'reviews',
					props: {
						reviewsData: {
							slug: 'business-reviews',
							headerTitle: 'Business Self Storage: ',
							reviews: reviews,
						},
					},
				},
			],
		},

		{
			title: 'Faqs Section',
			modules: [
				{
					type: 'faqs',
					props: {
						content: {
							header: 'Business Self Storage FAQs',
							image: FaQHeadingIcon,
							faqs,
						},
					},
				},
			],
		},
		{
			title: 'featured content',
			background: 'darkBlue',
			modules: [
				{
					type: 'featuredContent',
					props: {
						data: {
							heading: 'Learn All About Business Self Storage',
							slug: 'business-featured-content',
							data: {
								unitCards: [
									{
										title: 'Storage Tips',
										url: 'https://www.selfstorage.com/blog/business-and-commercial-storage-units-2/',
										date: 'May 20, 2025',
										image: ManAndWomanStorage,
										content:
											'Self-Storage Units: Business and Commercial Storage Spaces',
									},
									{
										title: 'Storage Tips',
										url: 'https://www.selfstorage.com/blog/small-business-inventory-storage-2/',
										date: 'August 26, 2025',
										image: ElevatingEfficiency,
										content:
											'Elevating Efficiency: Small Business Inventory Management with Self-Storage Solutions',
									},
									{
										title: 'Storage Tips',
										url: 'https://www.selfstorage.com/blog/how-to-create-a-self-storage-inventory/',
										date: 'May 29, 2025',
										image: Inventory,
										content:
											'How to Create a Self-Storage Inventory That Works',
									},
									{
										title: 'Storage Tips',
										url: 'https://www.selfstorage.com/blog/what-is-climate-controlled-storage-2/',
										date: 'August 19, 2025',
										image: IndoorclimateControlledStorageUnits,
										content:
											'Why Would You Need a Climate-Controlled Storage Unit?',
									},
								],
							},
						},
					},
				},
			],
		},
		{
			title: 'Link to other PSPs',
			background: 'lighterBlue',
			modules: [
				{
					type: 'links',
					props: {
						heading: {
							headingName: 'More ways to store',
						},
						id: 'storage size unit cards',
						linksList: storageCategories.commercialBusiness,
					},
				},
			],
		},
		{
			title: 'nearby units',
			modules: [
				{
					type: 'storageNearYou',
					props: {
						type: 'Commercial',
					},
				},
			],
		},
	],
};
